import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { useReviewFormSidebarData } from '../components/Sidebar/hooks/dataHooks';
import useReviewResultParams from '../hooks/useReviewResultParams';
import ResultSpiderChart from './components/ResultSpiderChart';

const FormContainer = styled.div`
  padding: 16px;
  padding-top: 0px;
`;

const ResultPageChartOnly = () => {
  const { reviewId, employeeId, providerId } = useReviewResultParams();

  const reviewData = useReviewFormSidebarData({
    reviewId,
    employeeId,
    providerId,
  });

  if (!reviewData.isLoading && reviewData.isError) {
    return null;
  }

  return (
    <FormContainer>
      <Flex gap={4} justifyContent="center">
        <ResultSpiderChart title="Competencies Spider Chart" isBigChart />
      </Flex>
    </FormContainer>
  );
};

export default ResultPageChartOnly;
